import React, { Fragment, } from 'react'
import { Link, } from 'react-router-dom'
import './style.css'
export default function MenuCard(props) {
    const { data } = props;
    return (
        <div className='IntroducePagesCard'>
            <img className='IntroducePagesCard_BackgroundImg' src={data.img} />
            <Link to={{ pathname: data.location, state: { index: data.index } }}>
                <div className='IntroducePagesCard_Content'>
                    <div className='IntroducePagesCard_ContentTitle'>{data.title}</div>
                    <div className='IntroducePagesCard_ContentTitleBottom'/>
                    <div className='IntroducePagesCard_ContentIntroduce'>{data.introduce}</div>
                </div>
            </Link>
        </div>
    )

}